export type EventSecReg = {
  slug: string
  title: string
}
type EventURL = string | null | undefined
export interface Event {
  eventId: string
  children?: any
  endDate?: string
  eventType?: string
  locationAddress: string
  locationCity: string
  locationCountry: string
  locationName: string
  regions: EventSecReg[]
  sectors: EventSecReg[]
  countries: EventSecReg[]
  startDate: string
  timeZone?: string
  timeZoneAbbreviation?: string
  formatTimeWithZoneAbbr?: string
  title: string
  isWebinar?: boolean
  vanityUrl: EventURL
  relativeVanityUrl: EventURL
}

export interface AugmentedEvent extends Event {
  url: string
}

type AugmentEventOptions = {
  useRelativeUrl?: boolean
}

const urlRegex = /^(?:(?:https?:)?\/\/)?(.*)$/

export function ensureHttps(url: EventURL) {
  if (typeof url !== 'string') {
    return ''
  }
  const match = urlRegex.exec(url)
  if (match) {
    return `https://${match[1]}`
  }
  return ''
}

export function augmentEvent<T extends Event>(
  event: T,
  options: AugmentEventOptions = {}
): T & { url: string } {
  return {
    ...event,
    url:
      options.useRelativeUrl && event.relativeVanityUrl
        ? event.relativeVanityUrl
        : ensureHttps(event.vanityUrl)
  }
}

export default {
  ensureHttps,
  augmentEvent
}
